"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupHTTPClient = setupHTTPClient;
exports.setupRequest = setupRequest;
exports.setupGatewayRequest = setupGatewayRequest;
exports.setupApiRequest = setupApiRequest;

var _toolkit = require("@weike/toolkit");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function setupHTTPClient(env) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var successCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var apiBaseURL = '/api';

  if (env !== 'production') {
    apiBaseURL = 'http://dbg.weike.fm/api';
  }

  if (config.baseURL) {
    apiBaseURL = config.baseURL;
  }

  return new _toolkit.HTTPClient(_objectSpread(_objectSpread({}, config), {}, {
    baseURL: apiBaseURL
  }), successCode);
}

function setupRequest(env) {
  var baseURL = env !== 'production' ? 'https://dbg.weike.fm/api' : 'https://m.lizhiweike.com/api';
  var http = setupHTTPClient(env, {
    baseURL: baseURL
  });
  return http;
}

function setupGatewayRequest(env) {
  var baseURL = env !== 'production' ? 'https://gateway.test.weike.fm' : 'https://gateway-weike.lizhiweike.com';
  var http = setupHTTPClient(env, {
    baseURL: baseURL
  }, '0000');
  return http;
}

function setupApiRequest(env) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v1';
  var baseURL = "https://api-gw.lizhiweike.com/".concat(version, "/api");

  if (env === 'development') {
    baseURL = "https://api.test.weike.fm/".concat(version, "/api");
  } else if (env === 'dbg') {
    baseURL = "https://api.test.weike.fm/".concat(version, "/api");
  }

  var http = setupHTTPClient(env, {
    baseURL: baseURL
  }, '0000');
  return http;
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/services/lib/lib/http.js
// module id = 579
// module chunks = 6